require('../components/ui-components/modal-bootstrap-v3.4.1');
require('../components/ui-components/animateOnScoroll');
require('../components/ui-components/scrollSnapArm');

const lazyImages = require('../components/ui-components/LazyLoad.js').lazyImages;
const videoPopup = require('../components/ui-components/VideoPopup').videoPopup;

const {onModeEnter, onModeLeave, getMode} = require('../media.js');
const StickyHeader = require('./StickyHeader').StickyHeader;
const Icons = require('../Icons.js').Icons;
const effects = require('../effects.js');

const debug = require('../debug.js');
const support = require('./support.js');
const $ = require("jquery");

const FeaturesAccordion = require('./FeaturesAccordion.js').FeaturesAccordion;

// we do not need it for a while
//global.Registration = require('../registration/registration').Registration;

global.Login = require('../login/login').Login;
global.Feedback = require('../feedback/feedback').Feedback;
global._t = _t;

//console.log('console.log in app.js')

new StickyHeader();
new Icons();

new FeaturesAccordion();

// Handle lazy loading images
lazyImages();
// Handle lazy loading youtube video in popups
videoPopup();

support.supportChat();

effects.addRippleToButton($('.btn, li.to-previous-step'));

debug.showScreenSize();

var menuWasOpen = false;

$('.header--togg-menu').click(function () {
    menuWasOpen = !menuWasOpen;
    closeMenu();
});

$('.morph-shape, .header--mob-togg-menu').click(function () {
    menuWasOpen = false;
    closeMenu();
});

function closeMenu() {
    if (menuWasOpen) {
        $('body').addClass('menu--opened');
        //$('#header').addClass('header--stickly');
        $('.header--togg-menu, .header .morph-shape').addClass('open');

        // AnimateSvgOpenMobile(function () {
            $('.header--main-nav').addClass('open');
        // });

    } else {
        $('body').removeClass('menu--opened');
        //$('#header').removeClass('header--stickly');
        $('.header--main-nav').removeClass('open');
        $('.header--main-nav .menu--link-has-dropdown .submenu').removeClass('opened');
        // AnimateSvgCloseMobile(function () {
            $('.header--togg-menu, .morph-shape').removeClass('open');
        // });
    }
}

$(window).resize(function () {
    if ($(window).width() > 768) {
        menuWasOpen = false;
        closeMenu();
    }
});



function toggleReviewText() {
    const reviewTextMinHeight = 105;
    let reviewBody = $(this).closest('.js-review-body');
    let reviewTextBlock = reviewBody.find('.js-review-body-text');
    let reviewShowLessBtn = reviewBody.find('.js-review-show-less');
    let reviewReadMoreBtn = reviewBody.find('.js-review-read-more');

    reviewReadMoreBtn.toggle();
    reviewShowLessBtn.toggle();

    if (reviewTextBlock.height() == 105) {
        reviewTextBlock.css('max-height', `${reviewTextBlock[0].scrollHeight}px`);
    } else {
        reviewTextBlock.css('max-height', `${reviewTextMinHeight}px`);
    }

    $('.js-review-body-text').not(reviewTextBlock).css('max-height', reviewTextMinHeight);
    $('.js-review-read-more').not(reviewReadMoreBtn).show();
    $('.js-review-show-less').not(reviewShowLessBtn).hide();
}

$('.js-review-read-more, .js-review-show-less').on('click', function() {
    toggleReviewText.apply($(this));
});

function openSubMenuOnTuch() {
    $('.header--navigation-menu-container').on('click', '.header--main-nav-mobile .menu--link-has-dropdown', function () {
        var get_data = $(this).data("submenu");
        var sub_menu = $(this).closest('.header--main-nav-mobile .main-nav--menu').find('#' + get_data);
        $(sub_menu).addClass('opened');
    });
}

openSubMenuOnTuch();

function goToPrevMenuOnTuch() {
    $('.header--navigation-menu-container ').on('click', '.header--main-nav-mobile .submenu .to-previous-step', function (e) {
        $('.submenu').removeClass('opened');
        e.stopPropagation();
    })
}

goToPrevMenuOnTuch();

function smoothScrollAnchorLinks() {
    $('.anchor-link').click(function (e) {
        e.preventDefault();
        $('.anchor-link').removeClass('active');
        //$(this).addClass('active');
        var target = $($(this).attr('href'));
        var offset_value = $(this).data('offset');

        if (getMode() != 'desktop') {
            offset_value = $(this).data('offset') - $(this).height();
        }
        if (getMode() == 'mob') {
            offset_value = 0;
        }

        $(window).resize(function () {
            if (getMode() != 'desktop') {
                offset_value = $(this).data('offset') - $(this).height();
            }
            if (getMode() == 'mob') {
                offset_value = 0;
            }
        });

        if (offset_value > 0) {
           // console.log('has offset');
            if (target.length) {
                var scrollTo = target.offset().top - offset_value;
                $('body, html').stop().animate({scrollTop: scrollTo + 'px'}, 800);
            }
        } else {
            //console.log('no offset');
            if (target.length) {
                var scrollTo = target.offset().top;
                $('body, html').stop().animate({scrollTop: scrollTo + 'px'}, 800);
            }
        }

    });
}

smoothScrollAnchorLinks();

function scrollToBlock(cur_block, callback, additionalOffset) {
    if ($(cur_block).length == 0) {
        return;
    }

    var isIn = checkIsIN();

    var additionalOffsetValue = additionalOffset;

    if (callback) callback(isIn);

    function checkIsIN() {
            var hT = cur_block.offset().top,
                hH = cur_block.outerHeight(),
                wH = $(window).height(),
                wS;

            if (additionalOffsetValue) {
                wS = $(window).scrollTop() + additionalOffsetValue;
            } else {
                wS = $(window).scrollTop();
            }


                return wS > (hT + hH - wH) && (hT > wS) && (wS + wH > hT + hH);
    }

    document.addEventListener('scroll', function () {
        if (checkIsIN()) {
           // console.log('in view');
            cur_block.addClass('in');
            if (!isIn) {
                if (callback) callback(true);
                isIn = true;
            }

        } else {
           // console.log('not in view');
            cur_block.removeClass('in');
            if (isIn) {
                if (callback) callback(false);
                isIn = false;
            }
        }
    }, {passive: true});
}

scrollToBlock($('.faq--question-list .container'), function (isIn) {
    if (isIn) {
        window.dispatchEvent(new Event('resize'));
    }
});



// Accept payments management carousel
var $carousel = $('.ap-management__carousel');
var $line = $carousel.find('.ap-management__line');

if ($carousel.length > 0) {
    $line.each(function (index, el) {
        $(this).clone().addClass('cloned').insertAfter(this);
    });
}

function _t(key, options) {
    let debugLang = false;
    let str = key;
    if (!(typeof LANG != 'undefined') && LANG[key]) {
        str = LANG[key];
    } else if (debugLang) {
        console.warn('Lang key missing', key);
    }

    if (options !== undefined) {
        for (let k in options) {
            if (options.hasOwnProperty(k)) {
                let v = options[k];
                str = (str + '').replace('%' + k + '%', v);
            }
        }
    }

    return str;
}

const toggleShortMenuDropdown = () => {
    const menuWithDropdown = $('.has-dropdown');

    menuWithDropdown.on('mouseenter', function () {
        menuWithDropdown.not(this).children('.menu__dropdown').removeClass('opened');
        $(this).children('.menu__dropdown').addClass('opened');
    });

    menuWithDropdown.on('mouseleave', function () {
        $(this).children('.menu__dropdown').removeClass('opened');
    });

    $(document).on('click', function (e) {
        if (!$(e.target).closest('.has-dropdown').length) {
            menuWithDropdown.children('.menu__dropdown').removeClass('opened');
        }
    });

    $(document).on('keydown', function (e) {
        if (e.key === 'Escape') {
            menuWithDropdown.children('.menu__dropdown').removeClass('opened');
        }
    });
};

toggleShortMenuDropdown();

if($('.masonry-grid--item-toggler').length){
	// Plain max-height transition (mirrors accordion.js) instead of jQuery
	// slideDown/slideUp, so opening/closing never depends on jQuery's own
	// reflow timing interacting with content-visibility/beforematch.
	// `instant` skips the height animation and jumps straight to the fully-open state —
	// used for the beforematch/Find-in-Page reveal path, where the browser calls its own
	// scrollIntoView() synchronously right after the handler returns; an animation still
	// in flight at that point scrolls to a layout that's about to change underneath it
	// (landing short, or cropped under the sticky header).
	const openFAQBody = ($body, instant = false) => {
		if ($body.hasClass('expanded')) return;
		const $toggler = $body.closest('.masonry-grid--item').find('.masonry-grid--item-toggler');
		$toggler.addClass('--active').attr('aria-expanded', 'true');
		$body.removeAttr('hidden').attr('aria-hidden', 'false').addClass('expanded');
		if (instant) {
			$body[0].style.maxHeight = 'none';
		} else {
			requestAnimationFrame(() => {
				if ($body.hasClass('expanded')) {
					$body.css('max-height', $body[0].scrollHeight + 'px');
				}
			});
		}
	};

	const closeFAQBody = ($body) => {
		if (!$body.hasClass('expanded')) return;
		const body = $body[0];
		// A fully-open panel has max-height released to "none" (see the transitionend
		// handler below) — CSS can't transition away from "none", so restore the exact
		// pixel height first (while .expanded/padding is still applied) and force a
		// reflow before collapsing, so the close animation always starts from a real value.
		const collapse = () => {
			$body.removeClass('expanded');
			body.style.maxHeight = '0px';
		};
		if (body.style.maxHeight === 'none') {
			body.style.maxHeight = body.scrollHeight + 'px';
			// A single rAF still lands in the same unpainted frame as this synchronous
			// write, so the browser never gets a chance to paint the restored value and
			// treats "none"→0 as an unanimatable jump. A second rAF forces a real paint
			// of the restored height first, so the collapse to 0 is a genuine transition.
			requestAnimationFrame(() => requestAnimationFrame(collapse));
		} else {
			requestAnimationFrame(collapse);
		}
		const $toggler = $body.closest('.masonry-grid--item').find('.masonry-grid--item-toggler');
		$body.attr('aria-hidden', 'true');
		// jQuery treats `hidden` as a boolean attribute and normalizes any truthy
		// .attr() value to "hidden", silently dropping "until-found" — must use
		// the native setAttribute to preserve the exact string find-in-page needs.
		body.setAttribute('hidden', 'until-found');
		$toggler.removeClass('--active').attr('aria-expanded', 'false');
	};

	$('.masonry-grid--item-header').on('click', function (){
		const $body = $(this).closest('.masonry-grid--item').find('.masonry-grid--item-body');
		if ($body.hasClass('expanded')) {
			closeFAQBody($body);
		} else {
			openFAQBody($body);
		}
	});

	// Browser find-in-page reveals hidden="until-found" content on its own;
	// this just syncs our --active/aria state to match.
	$('.masonry-grid--item-body').each(function () {
		this.addEventListener('beforematch', () => openFAQBody($(this), true));
		// Once the open transition finishes, release the height cap entirely so later
		// content/viewport changes are never clipped by a stale (or guessed) max-height.
		this.addEventListener('transitionend', (e) => {
			if (e.propertyName === 'max-height' && this.classList.contains('expanded')) {
				this.style.maxHeight = 'none';
			}
		});
	});
}


function setWithExpiry(key, value, ttl) {
    const now = new Date()
    const item = {
        value: value,
        expiry: now.getTime() + (ttl * 24 * 60 * 60 * 1000), // (ttl * 24 * 60 * 60 * 1000) - use for days, now in seconds (ttl - only in seconds)
    }
    localStorage.setItem(key, JSON.stringify(item))
}

function getWithExpiry(key) {
    const itemStr = localStorage.getItem(key)
    // if the item doesn't exist, return null
    if (!itemStr) {
        return null
    }
    const item = JSON.parse(itemStr)
    const now = new Date()
    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
        // If the item is expired, delete the item from storage
        // and return null
        localStorage.removeItem(key)
        return null
    }
    return item.value
}


if($('#cookies__close-btn')){
    $('#cookies__close-btn').on('click', function (){
        setWithExpiry('hideCookieCover', 1, 7);
        $('.cookies').addClass('cookies__footer-banner');
    })
}

if( getWithExpiry('hideCookieCover') != null ){
    $('.cookies').addClass('cookies__footer-banner');
} else{
    $('.cookies').removeClass('cookies__footer-banner');
}

console.log( 'hideCookieCover = ',  getWithExpiry('hideCookieCover'));
let cookieList = document.cookie;
let cookieListArr =  cookieList.split(';');
// console.log(cookieList)
// console.log( cookieList.split(';') )
// cookieListArr.map((item) => {
//     console.log(item)
// })

//hide cookie banner for Igor's pages & Michail's pages
if (window.location.href.indexOf("igor.dev18") > -1 || window.location.href.indexOf("memosh.dev18") > -1) {
    $('.cookies').fadeOut();
}


// Handle routing form popup iframe communication and UI logic
// Helper: apply a specific class to an element inside the iframe
function applyIframeClass() {
	const iframe = document.querySelector('#routing-form-sm__popup iframe');
	if (iframe && iframe.contentWindow) {
		iframe.contentWindow.postMessage({
			event: 'ADD_IFRAME_CLASS',
			selector: 'body',
			className: '--popup-iframe'
		}, '*');
	}
}

// Listen for messages from the iframe
window.addEventListener('message', function(event) {
	const data = event.data;
	const iframe = document.querySelector('#routing-form-sm__popup iframe');

	// When React inside the iframe is fully mounted
	if (data?.event === 'IFRAME_READY') {
		//console.log('IFRAME_READY: React inside the iframe is initialized');

		setTimeout(function () {
			applyIframeClass();
		})
	}

	// Update iframe height dynamically
	if (data?.event === 'ROUTING_FORM_HEIGHT') {
		if (iframe && data.height) {
			iframe.style.height = data.height + 'px';
		}
	}

	// When the form inside the iframe has been submitted
	if (data?.event === 'ROUTING_FORM_SUBMITTED') {
		//console.log('ROUTING_FORM_SUBMITTED received');

		const modal = document.querySelector('#routing-form-sm__popup .modal-dialog');
		if (modal) {
			setTimeout(function (){
				modal.classList.add('--wider');
				modal.style.transition = 'max-width 1s ease';
				modal.style.maxWidth = '920px';
			}, 350);
		}

		// Re-apply class inside the iframe after submission
		applyIframeClass();
	}
});

// Handle loader visibility and iframe loading logic
document.addEventListener('DOMContentLoaded', function() {
	const iframe = document.getElementById('routing-form-iframe');
	const loader = document.getElementById('routing-form-loader');
	const modal = $('#routing-form-sm__popup');

	if (!iframe || !modal.length) {
		return;
	}

	// Show loader when modal becomes visible
	modal.on('shown.bs.modal', function() {
		//console.log('Modal shown, displaying loader');

		const src = iframe.getAttribute('src');
		const dataSrc = iframe.getAttribute('data-src');

		// Show loader each time the modal is opened
		if (loader) loader.classList.remove('hidden');

		// Lazy-load the iframe only when opened
		if (!src || src.trim() === '') {
			//console.log('Loading iframe from data-src...');
			iframe.setAttribute('src', dataSrc);
		}
	});

	// When iframe finishes loading
	iframe.addEventListener('load', () => {
		//console.log('iframe loaded');
		if (loader) loader.classList.add('hidden');
	});

	// Reset iframe when modal is closed
	modal.on('hidden.bs.modal', function() {
		//console.log('Modal hidden, resetting iframe');

		const modalDialog = document.querySelector('#routing-form-sm__popup .modal-dialog');
		if (modalDialog) {
			modalDialog.classList.remove('--wider');
			modalDialog.style.maxWidth = '';
		}

		// Hide loader and remove src to fully reset the iframe
		if (loader) loader.classList.remove('hidden');
		iframe.setAttribute('src', '');
		//console.log('Iframe src cleared for next open');
	});
});

